import { MdCloudUpload, MdDoneAll, MdGrade } from 'react-icons/md';
import { useLocation } from 'react-router-dom';
import { Icon } from '@nbirl/nbi-common-ui-libs';
import classNames from 'classnames';

import { SidebarLink } from '../../../../shared/components';
import { PATHS } from '../../../../shared/constants';
import { AppFeature } from '../../../../shared/enum';
import { hasFeatureEnabled } from '../../../../shared/utils';
import { FavouritesCount } from '../../favourites/components';
import { PendingApprovalCount } from '../../pending-approval/components';
import { UploadsCount } from '../../uploads/components';
import { ResourceLink } from '../models';

export const ResourceLinks = () => {
  const { pathname } = useLocation();

  const links: ResourceLink[] = [
    {
      icon: MdDoneAll,
      title: <PendingApprovalCount />,
      path: PATHS.PendingApproval,
      requiredFeature: AppFeature.PendingApproval,
    },
    {
      icon: MdGrade,
      title: <FavouritesCount />,
      path: PATHS.Favourites,
    },
    {
      icon: MdCloudUpload,
      title: <UploadsCount />,
      path: PATHS.Uploads,
    },
  ].filter((link) => hasFeatureEnabled(link.requiredFeature));

  return (
    <ul className="p-2 border-b border-gray-100">
      {links.map(({ icon: QuickFilterIcon, title, path }) => (
        <li key={path}>
          <SidebarLink path={path}>
            <Icon
              icon={
                <QuickFilterIcon
                  className={classNames('flex-none text-xl text-primary-200', {
                    'text-primary-500': pathname.includes(path),
                  })}
                />
              }
            />
            <span
              className={classNames({
                'text-primary-500': pathname.includes(path),
              })}
            >
              {title}
            </span>
          </SidebarLink>
        </li>
      ))}
    </ul>
  );
};
